document.addEventListener('click', function(event) {
    var target = event.target;
    if (target.classList.contains('add-selling-plan')) {
        event.preventDefault();
        target.style.display = 'none';
        // let currentItemPlanSelector = target.closest('.cart-grid-item').querySelector('.selling-plan-select');
        // currentItemPlanSelector.classList.remove('transparent');
        // target.closest('.cart-grid-item').querySelector('.selling-plan-select').classList.remove('hidden');
        // let defaultValue = currentItemPlanSelector.querySelector('optgroup[label="Subscribe & Save"] option:not([disabled])').value;
        // currentItemPlanSelector.value = defaultValue;
        // console.log('updated item value');
        // currentItemPlanSelector.dispatchEvent(new Event('input'));
    }
});

function updateItemSellingPlan(event) {
    console.log('plan updated');

    let currentItemPlanSelector = event.target;
    let sellingPlanToggle = currentItemPlanSelector.closest('.cart-grid-item__subscription-upsell').querySelector('.add-selling-plan');
    if(currentItemPlanSelector.value === 'null') {
      sellingPlanToggle.classList.remove('hidden');
      currentItemPlanSelector.classList.add('transparent');
    } else {
      sellingPlanToggle.classList.add('hidden');
      currentItemPlanSelector.classList.remove('transparent');
    }
    var cartMini = document.querySelector('cart-mini');
    var itemKey = event.target.getAttribute('data-item-key');
    var sellingPlanID = event.target.value === "null" ? null : event.target.value;
    var itemProperties = event.target.getAttribute('data-item-properties');
    const currentProperties = itemProperties ? JSON.parse(itemProperties).reduce((prev, curr) => {prev[curr[0]] = curr[1]; return prev}, {}) : {};
    const tontineProperties = Object.keys(currentProperties).includes('_tontinePriceVariant') ? (() => {
      const variantId = event.target.getAttribute('data-item-id');
      const tontineVariant = window.TontineApp?.variantPrices?.[variantId] || null;
      if (!variantId || !tontineVariant) {
        return {};
      }
      if (sellingPlanID === null) {
        return {_tontineBValue: tontineVariant.number};
      }
      const variation = window.TontineApp?.app?.variation?.get(tontineVariant.trafficSplit, tontineVariant.multiarmed == 'true');
      const sellingPlan = tontineVariant.sellingPlans?.find(plan => plan.id == sellingPlanID);
      if (!sellingPlan || !variation || variation == 'a') {
        return {}
      }
      const sellingPlanDiscount = sellingPlan.value_type == 'percentage' ? tontineVariant.number * (Number(sellingPlan.value) / 100) : tontineVariant.number - Number(sellingPlan.value);
      return {_tontineBValue: Math.round(tontineVariant.number - sellingPlanDiscount)};
    })() : {}

    // Make the AJAX request
    fetch('/cart/change', {
        ...fetchConfig('javascript'),
        body: JSON.stringify({
            id: itemKey,
            selling_plan: sellingPlanID,
            properties: {
              ...currentProperties,
              ...tontineProperties
            }
        })
    })
    .then((response) => response.json())
    .then((parsedState) => {
        document.dispatchEvent(new Event('productAddSuccess'));
        document.dispatchEvent(Events().itemAdded._event(parsedState));
    })
    .catch((e) => {
        console.error(e);
    })
    .finally(() => {
        cartMini.setAttribute('data-updating', "updated");
    });
}